import { combineReducers } from '@reduxjs/toolkit';

import loginReducer from '../containers/Auth/loginSlice';
import mainLayoutReducer from '../containers/MainLayout/mainLayoutSlice';
import dashboardReducer from '../containers/Dashboard/dashboardSlice';
import editTrackerReducer from '../containers/EditTraker/editTrakerSlice';
import DealerComparisonReducer from '../containers/DealerComparison/comparisonSlice';
import inventoryReducer from '../containers/Inventory/inventorySlice';
import importTreeReducer from '../pages/Import/TreeView/ImportTreeSlice';
import importTableSlice from '../pages/Import/TableView/ImportTableSlice';
import exportTableSlice from '../pages/Export/TableView/ExportTableSlice';
import mavisTableSlice from '../pages/Mavis/TableView/MavisTableSlice';
import videoGenerationReducer from '../containers/VideoGeneration/videoGenerationSlice';
import youtubeThumbnailReducer from '../containers/YoutubeThumbnail/YoutubeThumbnailSlice';
import PromotionalBannersSlice from '../containers/PromotionalBanners/PromotionalBannersSlice';
import PromoBillboardsSlice from '../containers/PromoBillboards/PromoBillboardsSlice';
import ExportDMSSlice from '../containers/ExportDMS/ExportDMSSlice';
import ImportDMSSlice from '../containers/ImportDMS/ImportDMSSlice';
import dealerProfileSlice from '../containers/DealerProfile/dealerProfileSlice';
import userRoleSlice from '../containers/UserRoles/userRoleSlice';
import accountsSlice from '../containers/Accounts/accountsSlice';
import photographerAccountsSlice from '../containers/PhotographerAccount/photographerAccountsSlice';
import windowStickerSlice from '../pages/WindowSticker/windowStickerSlice';
import MavisModalSlice from '../components/MavisModal/MavisModalSlice';

// Combine all reducers
const appReducer = combineReducers({
  auth: loginReducer,
  accounts: accountsSlice,
  mainlayout: mainLayoutReducer,
  dashboard: dashboardReducer,
  editTracker: editTrackerReducer,
  photographerAccounts: photographerAccountsSlice,
  dealerComparison: DealerComparisonReducer,
  inventory: inventoryReducer,
  importTreeReducer: importTreeReducer,
  videogeneration: videoGenerationReducer,
  youtubethumbnail: youtubeThumbnailReducer,
  promotionalBanners: PromotionalBannersSlice,
  promoBillboards: PromoBillboardsSlice,
  exportDMS: ExportDMSSlice,
  importDMS: ImportDMSSlice,
  mavisModal: MavisModalSlice,
  dealerProfile: dealerProfileSlice,
  ws: windowStickerSlice,
  role: userRoleSlice,
  // v2
  importTableReducer: importTableSlice,
  exportTableReducer: exportTableSlice,
  mavisTableReducer: mavisTableSlice
});

// Root reducer with logout handling
const rootReducer = (state, action) => {
  if (action.type === 'auth/handleAuthLogout') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
